import {NgModule, ApplicationRef} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {CommonModule} from '@angular/common';
import {HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule, Routes} from '@angular/router';
import {SharedModule} from '../../commons/shared.module';
import {VasatQMAPService} from '../../commons/app.service';
import { ExplorerComponent } from './explorer.component';
import { QMAPModule,QMAPService } from 'ng-qmap';

const AppRoutes: Routes = [

    { path: '', redirectTo: 'Dataset', pathMatch: 'full'},
    { path: ':filter', component:ExplorerComponent, pathMatch: 'full'},
    { path: ':filter/:folderId', component:ExplorerComponent, pathMatch: 'full'}


];

@NgModule({
    imports: [
    QMAPModule,
        FormsModule,
        CommonModule,
        SharedModule,
        RouterModule.forChild(AppRoutes)
    ],
    providers:[
        {
            provide:QMAPService,
            useClass:VasatQMAPService
        }
    ],

    declarations: [
        // ExplorerComponent

    ],
    entryComponents:[
    ],
  exports: [
    // ExplorerComponent
    ]
})

export class ExplorerModule {


}
